import { MessageBus } from '@podium/browser';
import React from 'react';
import { useLayout, type Layout } from './LayoutStore';

const SEARCH_CHANNEL = 'search';
const LAYOUT_TOPIC = 'layout';

const messageBus = new MessageBus();

type SearchLayoutPayload = {
    layout: Layout;
};

export function useSearchLayoutMessage() {
    const { layout } = useLayout();

    const isInitialRender = React.useRef(true);

    React.useEffect(
        function publishUpdates() {
            if (isInitialRender.current) {
                isInitialRender.current = false;
                return;
            }
            const payload: SearchLayoutPayload = {
                layout,
            };
            messageBus.publish(SEARCH_CHANNEL, LAYOUT_TOPIC, payload);
        },
        [isInitialRender, layout],
    );
}
